const fb = require('@/firebase/config.js');

export default {
    namespaced: true,
    state: {
        printJobs: [],
        printJobsListener: null
    },

    getters: {
        getPrintJobByOrderId: (state) => (orderId) => {
            // Findet den aktuellsten Print Job für eine Order ID
            const jobs = state.printJobs.filter(job => job.orderId === orderId);
            if (jobs.length === 0) return null;
            // Sortiere nach created Datum, neueste zuerst
            return jobs.sort((a, b) => {
                const aTime = a.created?.seconds || 0;
                const bTime = b.created?.seconds || 0;
                return bTime - aTime;
            })[0];
        },
        getAllPrintJobsByOrderId: (state) => (orderId) => {
            // Findet ALLE Print Jobs für eine Order ID
            const jobs = state.printJobs.filter(job => job.orderId === orderId);
            // Sortiere nach created Datum, neueste zuerst
            return jobs.sort((a, b) => {
                const aTime = a.created?.seconds || 0;
                const bTime = b.created?.seconds || 0;
                return bTime - aTime;
            });
        }
    },

    mutations: {
        setPrintJobs(state, payload) {
            state.printJobs = payload;
        },
        setPrintJobsListener(state, listener) {
            state.printJobsListener = listener;
        }
    },

    actions: {
        setupPrintJobsListener({ commit }) {
            const unsubscribe = fb.printJobsCollection
                .orderBy('created', 'desc')
                .onSnapshot((snapshot) => {
                    const printJobs = [];
                    snapshot.forEach((doc) => {
                        const data = doc.data();
                        printJobs.push({
                            id: doc.id,
                            orderId: data.orderId || '-',
                            created: data.created,
                            assignedAt: data.assignedAt,
                            assignedTo: data.assignedTo,
                            state: data.state || 'unknown',
                            deviceId: data.deviceId || '-',
                            quantity: data.quantity || 0
                        });
                    });
                    commit('setPrintJobs', printJobs);
                }, (error) => {
                    console.error('Error listening to printJobs:', error);
                });

            commit('setPrintJobsListener', unsubscribe);
        },

        removePrintJobsListener({ state }) {
            if (state.printJobsListener) {
                state.printJobsListener();
            }
        },

        printJob (context, order) {
            console.log('create print job', order)

            const data = {
                orderId: order.id,
                recreate: true
            }

            return new Promise((resolve, reject) => {
                const createPrintTask = fb.fire.app()
                    .functions('europe-west1')
                    .httpsCallable('taskCreatePrintJobCall')
                createPrintTask(data)
                  .then((result) => {
                      console.log('result', result)
                      resolve(result)
                  })
                  .catch((error) => {
                      console.log('error', error)
                      reject(error)
                  })
            })
        }
    }
}
